import $ from 'jquery';
import langFromUrl from 'lib/util/langFromUrl';
import responsive from 'lib/responsive';
import tdaConfig from 'lib/util/tda.config';
import zip from 'lib/util/zip';

export default {

  breadCrumb: {
    dealerDetail: {
      en: {
        text: 'View All Dealers',
        url: '/' + tdaConfig.site.context_url + '/dealers'
      },
      es: {
        text: 'Ver todos los concesionarios',
        url: '/' + tdaConfig.site.context_url + '/dealers'
      }
    },
    offerDetail: { // currently unused as it comes from offer.detail.hbs (initOld legacy function)
      en: {
        text: 'View offers',
        url: '/' + tdaConfig.site.context_url + '/offers'
      },
      es: {
        text: 'Ver ofertas',
        url: '/' + tdaConfig.site.context_url + '/offers'
      }
    },
    inventoryResults: {
      en: {
        text: 'View All Vehicles',
        url: '/' + tdaConfig.site.context_url + '/inventory'
      },
      es: {
        text: 'Ver todos los vehículos',
        url: '/' + tdaConfig.site.context_url + '/inventory'
      }
    }
  },

  // breadcrumbs are currently only on
  // - dealer detail page
  // - inventory results page
  // - inventory detail page
  // - offer detail
  getCurrentPage: function () {
    return {
      isDealerDetailPage: !!$('div[data-component-name="Dealer-Detail"]').length,
      isInventoryVehiclePage: !!$('div[data-component-name="Inventory-Vehicle"]').length,
      isInventoryDetailPage: !!$('div[data-component-name="Inventory-Detail"]').length,
      isOfferDetailPage: !!$('div[data-component-name="Offer-Detail"]').length
    };
  },

  // display the breadcrumbs only if landing on one of the (currently) four breadcrumb pages
  displayBreadcrumbs: function () {
    var self = this;
    var page = self.getCurrentPage();
    if (page.isOfferDetailPage && responsive() === 'sm') {
      $('.breadcrumb').addClass('row');
    }

    if (page.isDealerDetailPage
      || page.isInventoryVehiclePage
      || page.isInventoryDetailPage
      || page.isOfferDetailPage) {
      $('.breadcrumb').show();
    }
  },

  // used in inpage-headline.js to build the breadcrumbs for the hbs template
  buildBreadcrumbs: function () {
    var self = this;
    var page = self.getCurrentPage();
    var breadCrumbObj = {};
    if (page.isDealerDetailPage) {
      breadCrumbObj = self.breadCrumb.dealerDetail[langFromUrl()];
    } else if (page.isInventoryVehiclePage) {
      breadCrumbObj = self.breadCrumb.inventoryResults[langFromUrl()];
    } else if (page.isInventoryDetailPage) {
      breadCrumbObj = self.breadCrumb.inventoryResults[langFromUrl()];
    } else if (page.isOfferDetailPage) {
      breadCrumbObj = self.breadCrumb.offerDetail[langFromUrl()];
    }
    return breadCrumbObj;
  },

  // add series to the breadcrumb text and link so the page will
  // go back to the search results for that series
  updateInventoryDetailBreadcrumb: function (name, series) {
    var seriesFriendlyName = name.split(' ');
    seriesFriendlyName = seriesFriendlyName[0];
    if (langFromUrl() === 'en') {
      $('#breadcrumb-link').html('<i class="icon icon-arrow-l"></i> View ' + seriesFriendlyName + ' Inventory');
      $('#breadcrumb-link').attr('href', '/' + tdaConfig.site.context_url + '/inventory/results/?series=' + series);
    } else {
      $('#breadcrumb-link').html('<i class="icon icon-arrow-l"></i> Ver ' + seriesFriendlyName + ' inventario');
      $('#breadcrumb-link').attr('href', '/' + tdaConfig.site.context_url + '/inventory/results/?series=' + series);
    }
  },

  // add the cookied or default zip to the breadcrumb link so the page will
  // go back to the search results for that zip
  updateDealerDetailBreadcrumb: function () {
    var defaultZip = (zip.getCookiedDefaultFallback()) ? zip.getCookiedDefaultFallback() : zip.getDefault();
    if (defaultZip) {
      $('#breadcrumb-link').attr('href', '/' + tdaConfig.site.context_url + '/dealers/?zipcode=' + defaultZip);
    }
  }

};
